import { useContext, useState, useEffect, useRef } from 'react';
import PageContext from './PageContext';
import { HttpContext } from '../../api-services/HttpService';
import { useSelector } from "react-redux";
import ApiRequestButton from './ApiRequestButton';
import DynamicPageInput from './DynamicPageInputCopy.jsx';
import validateInputArray from '../functions/validateInputArray';
import dynamicValidation from '../functions/dynamicValidation';
import dynamicTransformation from '../functions/dynamicTransformation';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const AddConsortiumRebateSetup = () => {
    // get page context from parent
    const {
        addConsortiumGroupModal,
        setAddConsortiumGroupModal,
        snackbarAlert,
        getRefreshData,
        groupInputConfig,
        groupInputLists,
    } = useContext(PageContext);
    // get HTTP context from parent
    const {
        POST,
    } = useContext(HttpContext);
    // get global redux state 
    const consortiumId = useSelector((state) => state.consortiumId);
    // initialize state 
    const [values, setValues] = useState({});
    const [config, setConfig] = useState([]);
    const [error, setError] = useState([{}]);

    // event handler for submit click 
    const onSubmitClick = () => {
        return new Promise((resolve, reject) => {
            let requestValues = [{ ...values }];
            // dynamically validate and transform inputs 
            let checkError = validateInputArray(
                requestValues,
                groupInputConfig,
                dynamicValidation,
                groupInputLists,
                snackbarAlert,
                error,
                setError,
                dynamicTransformation,
                {
                    achaccountnumber: {
                        clearachinfo: values['payoutmethodid']['clearachinfo']
                    },
                    achbankabanumber: {
                        clearachinfo: values['payoutmethodid']['clearachinfo']
                    },
                    achaccounttype: {
                        clearachinfo: values['payoutmethodid']['clearachinfo']
                    }
                }
            );
            // exit request if error 
            if (checkError) {
                reject();
                return;
            }
            // use POST function to make query 
            POST('/consortium/consortiumGroup', {
                consortiumid: consortiumId,
                ...requestValues[0],
            }).then(res => {
                console.log(res);
                // default values 
                setValues(values => values = {});
                // show snackbar on success
                snackbarAlert(true, 'Successfully added group.', 'success');
                // hide modal
                setAddConsortiumGroupModal(addConsortiumGroupModal => addConsortiumGroupModal = false);
                // refresh data 
                return getRefreshData();
            }).then(res => {
                // reject on success
                resolve(res);
            }).catch(err => {
                console.log(err);
                // show snackbar on failure
                snackbarAlert(true, 'Error adding group.', 'error');
                // reject on error
                reject(err);
            });
        });
    }

    // useEffect to run on config change 
    useEffect(() => {
        if (groupInputConfig) {
            setConfig(config => config = groupInputConfig);
        }
    }, [groupInputConfig]);

    return (
        <>
            <CCOffcanvas
                title={`Add Consortium Group`}
                show={addConsortiumGroupModal}
                onCanvasClose={() => setAddConsortiumGroupModal(addConsortiumGroupModal => addConsortiumGroupModal = false)}
                bodyCssClassName="offcanvas-body bg-white p-3"
                offCanvasClassName="offcanvas-parent-card-30"
            >   
                <div className="d-flex flex-column h-100">
                    <div className="d-flex flex-column gap-3 flex-grow-1 overflow-scroll">
                        {config.map((el) =>
                            <>
                                <div>
                                    <DynamicPageInput data={values} setData={setValues} config={el} args={groupInputLists} width={'100%'} topAlignTypography={true} />
                                </div>
                            </>
                        )}

                    </div>
                    <div
                        className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                    >
                        <ButtonComponent tag={"Cancel"}
                            border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'}
                            onButtonClick={() => setAddConsortiumGroupModal(addConsortiumGroupModal => addConsortiumGroupModal = false)}
                        />
                        {/* button to submit company entitlement edit */}
                        <ApiRequestButton onButtonClick={onSubmitClick} />
                    </div>
                </div>
            </CCOffcanvas>

        </>
    );
}

export default AddConsortiumRebateSetup; 